export const APP_VERSION = "v8.1";

export const FRONT_MATTER_TAG = "Career Climb Front Matter";

/* version up v8.1 derived from v8.1.rc001 */
/* trigger another client build */
export const PATHWAY_PERSONALITY_HIGHLY_RECOMMENDED = 0.75;
export const PATHWAY_PERSONALITY_RECOMMENDED = 0.5;
export const PATHWAY_PERSONALITY_NON_LOSE = 0.25;

// RIASEC score thresholds used on the back of the hat card to bucket a hat
// into "Great for" / "Tough for" RIASEC types, and reused by the hat-finder
// "High Interest" / "Low Interest" filter so all three views stay in sync.
export const RIASEC_HIGH_INTEREST_MIN_SCORE = 4.5;
export const RIASEC_LOW_INTEREST_MAX_SCORE = 3;
// Low-interest also requires a real (non-zero) score so unscored hats that
// default to 0 aren't pulled into the "Low Interest" bucket.
export const RIASEC_LOW_INTEREST_MIN_SCORE = 1;

export const CLEVER_LOGIN_METHOD = "Clever";
export const CLASSLINK_LOGIN_METHOD = "ClassLink";
export const BULK_LOGIN_METHOD = "LMS / SIS / Bulk CSV";
export const MANUAL_LOGIN_METHOD = "Manual";
export const NYC4D_LOGIN_METHOD = "nyc4d";
export const NYC4D_LOGIN_METHOD_DISPLAY = "NYC.ID";

// Login methods that can be edited by the district admin
export const EDIT_LOGIN_METHODS = [MANUAL_LOGIN_METHOD, BULK_LOGIN_METHOD];
